import { c as _c } from "react/compiler-runtime";
import FooterAppDownloads from "./FooterAppDownloads";
import FooterBrand from "./FooterBrand";
import FooterNavLinks from "./FooterNavLinks";
export default function FooterMiddle() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-full px-4 sm:px-6 md:px-10 py-8 md:py-10"><div className="mx-auto container max-w-3xl flex flex-col md:flex-row items-center md:items-start justify-between gap-8 md:gap-6"><FooterBrand /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}